import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import loginType from "../../redux/actions/login/loginType";

import LoadingComponent from "../../components/public/loading";

export default function LoginByToken() {
    let params = new URLSearchParams(window.location.search);
    const dispatch = useDispatch();
    const loginDetail = useSelector((state) => state.loginDetail);
    const user = useSelector((state) => state.userDetail);

    useEffect(() => {



        if (params.get("view-port") == "iframe" || window.location !== window.parent.location) {
            if (params.get("token")) {

                if (user.userToken == params.get("token")) {
                    window.location = params.get("callback")
                } else {
                    dispatch({
                        type: loginType.LOGIN_USER_BY_TOKEN,
                        token: params.get("token"),
                        prevPath: params.get("callback")
                    });
                }
            }
        }
    }, [])

    return (
        <div>
            <div className="">
                <LoadingComponent />
            </div>
        </div>
    )
}
